import { render } from "./Biens.vue?vue&type=template&id=1d228e14&scoped=true"
import script from "./Biens.vue?vue&type=script&lang=js"
export * from "./Biens.vue?vue&type=script&lang=js"

import "./Biens.vue?vue&type=style&index=0&id=1d228e14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d228e14"]])

export default __exports__